import { ApiPriceBook } from '@vend/types'
import { VdFeatureManager } from '@vend/vend.js'
import { EntityStore } from './entity-store'

/**
 * Stores information on the retailer's price books.
 *
 * @class PriceBooksStore
 * @constructor
 * @extends EntityStore
 */
class PriceBooksStore extends EntityStore<'priceBooks'> {
  constructor() {
    'ngInject'
    super({
      entityStoreName: 'priceBooks',
      entityName: 'price_books',
    })
  }

  /**
   * Determine whether the given price book should be saved to the IndexedDB store or removed. Price books
   * with a null `name` property (indicative of a hard delete) will be removed from the IndexedDB store.
   *
   * @param  entityData
   *         The data for the price book entity as returned by the API end point
   *
   * @return true if the entity should be stored, false if it should be removed
   */
  protected shouldStoreEntity(entityData: ApiPriceBook) {
    return entityData.name !== null
  }

  /**
   * Get the url of the entity
   *
   * @returns {string}
   */
  public getUrl(
    entitySyncConfig: $TSFixMe,
    vdFeatureManager: VdFeatureManager
  ): string {
    const { entityVersion } = entitySyncConfig.data
    if (vdFeatureManager.get('price_book_subsets')) {
      return `/api/3.0/${entityVersion.entityName}`
    }
    return super.getUrl(entitySyncConfig, vdFeatureManager)
  }
}

export const priceBooksStore = new PriceBooksStore()
